define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_LINK_HEIGHT_PERCENTAGE = 40;
    const DEFAULT_LINK_WIDTH_PERCENTAGE = 20;

    /**
     * Model for a link widget.
     *
     * @class LinkWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("LinkWidgetModel", {
        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "link",
            width: DEFAULT_LINK_WIDTH_PERCENTAGE,
            height: DEFAULT_LINK_HEIGHT_PERCENTAGE
        }),

        initialize() {
            AbstractWidgetModel.prototype.initialize.call(this);
        },

        fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/linkWidget/LinkWidgetModel.js